import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AccountService} from '../../../_services/account.service';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Router, UrlSerializer} from '@angular/router';
import { HomeService } from 'src/app/home/home.service';

const API_URL = environment.apiUrl;

@Component({
  selector: 'app-materia-card',
  standalone: false,
  templateUrl: './materia-card.component.html',
  styleUrls: ['./materia-card.component.scss']
})
export class MateriaCardComponent implements OnInit {

  @Input()
  materia;
  @Input()
  hijo?;

  @Output()
  detalleOpen = new EventEmitter();

  currUser;

  constructor(private accountService: AccountService,
              private homeService: HomeService,
              private router: Router,
              private serializer: UrlSerializer,
              private http: HttpClient) {
  }

  openExternalLink(url: string): void {
    window.open(url, '_blank');
  }
  

  ngOnInit() {
    this.currUser = this.accountService.getUser();
  }

  getUrl(url) {
    const splitedUrl = url.split('#'),
      tree = this.router.createUrlTree(splitedUrl[0].split('/'), {fragment: splitedUrl.length > 1 ? splitedUrl[1] : ''});

    return this.serializer.serialize(tree);
  }

  navigate(url) {
    const splitedUrl = url.split('#'),
      tree = this.router.createUrlTree(splitedUrl[0].split('/'), {fragment: splitedUrl.length > 1 ? splitedUrl[1] : ''});

    this.router.navigateByUrl(tree);
  }

  getServiceData(item) {
    const url = `${API_URL}/${item.urlApi}`;
    this.detalleOpen.emit(true);
    this.homeService.getApiService(url).subscribe(res => {
      item.detalle = this.homeService.extractData(res);
    }, err => {
      this.detalleOpen.emit(false);
    });
  }
}
